import React, { useState } from "react";

import "./IbanInput.scss";
import { t } from "i18next";

interface IIbanInput {
  ibanValue?: string | null;
  setIbanValue?: React.Dispatch<React.SetStateAction<string | null>>;
}

const IbanInput = ({ ibanValue, setIbanValue }: IIbanInput) => {
  const [inputFocused, setInputFocused] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIbanValue && setIbanValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (ibanValue && ibanValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="name"
            step={0}
            defaultValue=""
            value={ibanValue || ""}
            onChange={onChangeInput}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">
            {t("admin.Iban")}
          </span>
        </label>
      </div>
    </div>
  );
};

export { IbanInput };
